import { ref } from "vue";
import { LoginError } from "~/components/Page/Login/errors";
import { ROUTES } from "~/helpers/routes/routes";

export function useLoginHandler() {
  const { login, user } = useUser();
  const { selectBranchFromCurrentUser } = useBranchCurrentUser();
  const { fetchCart } = useCart();
  const { currentError, handleErrorByStatus, clearError } = useErrorHandler<LoginError>("login");

  const email = ref<string>("");
  const password = ref<string>("");
  const isLoggingIn = ref<boolean>(false);

  const handleLogin = async ({ isCheckout = false, redirectOnSuccess = false } = {}) => {
    isLoggingIn.value = true;
    clearError();

    try {
      await login({
        email: email.value,
        password: password.value,
        isCheckout,
      });

      if (user.value) {
        if (redirectOnSuccess) {
          const router = useRouter();

          const { routerHistory } = useRouterHistory();
          const previousPath = routerHistory.value as ROUTES;

          const noReturnRoutes = [
            ROUTES.CREATE_CASH_SUCCESS,
            ROUTES.SET_PASSWORD,
            ROUTES.RESET_PASSWORD,
            ROUTES.FORGOTTEN_PASSWORD,
          ];

          const shouldNotReturn = noReturnRoutes.some((route) => previousPath && previousPath.startsWith(route));

          router.push(previousPath && !shouldNotReturn ? previousPath : ROUTES.ACCOUNT_DASHBOARD);
        }

        await selectBranchFromCurrentUser();
        await fetchCart();
        return { success: true };
      }

      return { success: false };
    } catch (error) {
      handleErrorByStatus(error as ApiError);
      return { success: false };
    } finally {
      isLoggingIn.value = false;
    }
  };

  const resetForm = () => {
    email.value = "";
    password.value = "";
    clearError();
  };

  return {
    email,
    password,
    isLoggingIn,
    currentError,
    handleLogin,
    clearError,
    resetForm,
  };
}
